import React, { useEffect, useState } from 'react';
import API from '../api';
import GuardedCheckoutConsent, { useGuardedCheckout } from '../components/GuardedCheckout';

const PACK_COPY = {
  topup_10: { label: 'Try AI Rebuild', copy: 'For a few images or occasional reconstruction work.' },
  topup_25: { label: 'Creator', copy: 'For regular 4K and print reconstruction work.' },
  topup_60: { label: 'Pro', copy: 'For frequent rebuilds or larger working sets.' },
  topup_120: { label: 'Studio', copy: 'For sustained commercial reconstruction work.' },
};

const FALLBACK_PACKS = [
  { topup_key: 'topup_10', credits: 10, price_aud: 5.99 },
  { topup_key: 'topup_25', credits: 25, price_aud: 12.99 },
  { topup_key: 'topup_60', credits: 60, price_aud: 29.99 },
  { topup_key: 'topup_120', credits: 120, price_aud: 60 },
];

export default function AiRebuildPurchasePanel() {
  const checkout = useGuardedCheckout();
  const [packs, setPacks] = useState(FALLBACK_PACKS);
  const [loadingKey, setLoadingKey] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    API.get('/v1/topup/options').then((response) => {
      const options = response.data?.options || response.data?.topups;
      if (Array.isArray(options) && options.length) setPacks(options);
    }).catch(() => {});
  }, []);

  async function buy(pack) {
    const key = pack.topup_key || pack.key;
    setLoadingKey(key);
    setError('');
    try {
      const response = await checkout.start(
        () => API.post('/v1/topup/checkout', { topup_key: key }),
        { purchaseType: 'topup', intendedSelector: key },
      );
      if (response.data?.checkout_url) {
        window.location.href = response.data.checkout_url;
        return;
      }
      setError('Could not start checkout. Please try again.');
    } catch (purchaseError) {
      setError(purchaseError.response?.data?.error || 'Could not start checkout. Please try again.');
    } finally {
      setLoadingKey('');
    }
  }

  return (
    <>
      <GuardedCheckoutConsent checkout={checkout} />
      {error ? <p className="ctmi-status error" role="alert">{error}</p> : null}
      <div className="ctmi-plans putmi-credit-grid">
        {packs.map((pack) => {
          const key = pack.topup_key || pack.key;
          const copy = PACK_COPY[key] || { label: pack.label || 'Creation Credits', copy: 'Credits for VISINVOKE cloud creation actions.' };
          const credits = pack.credits ?? pack.specs;
          const price = pack.price_aud ?? pack.price;
          return (
            <article key={key}>
              <small>{copy.label}</small>
              <h3>{credits} Creation Credits</h3>
              <p className="price"><b>{price == null ? 'Price shown at checkout' : `A$${Number(price).toFixed(2)}`}</b></p>
              <p>{copy.copy} The exact rebuild cost is shown before submission.</p>
              <button className="ctmi-button" type="button" disabled={loadingKey === key} onClick={() => buy(pack)}>
                {loadingKey === key ? 'Starting checkout…' : 'Buy credits'}
              </button>
            </article>
          );
        })}
      </div>
    </>
  );
}
